import React from 'react';

export const Directories = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12.738 14.043a5.217 5.217 0 1 0 10.434 0 5.217 5.217 0 0 0-10.434 0ZM1 7.521a1.957 1.957 0 1 0 3.913 0 1.957 1.957 0 0 0-3.913 0v0ZM27.087 2.957a1.957 1.957 0 1 0 3.913 0 1.957 1.957 0 0 0-3.913 0v0ZM1 29.043a1.957 1.957 0 1 0 3.914 0 1.957 1.957 0 0 0-3.914 0v0ZM15.999 29.043a1.957 1.957 0 1 0 3.914 0 1.957 1.957 0 0 0-3.914 0v0ZM4.34 27.66l9.938-9.915M21.651 10.361l6.007-6.02M4.717 8.37l8.442 3.619M27.168 18.647l-4.72-1.95M17.955 27.087v-7.826M27.087 19.26a1.957 1.957 0 1 0 3.913 0 1.957 1.957 0 0 0-3.913 0v0Z"
            stroke="currentColor"
        />
    </svg>
);
